import type { ThinkingLevel } from "../store/TaskModel"
import { Select } from "./ui/Select"

const THINKING_ENTRIES: Array<{ id: ThinkingLevel; content: string }> = [
    { id: "low", content: "Low" },
    { id: "med", content: "Med" },
    { id: "high", content: "High" },
    { id: "max", content: "Max" },
]

export function ThinkingPicker({
    value,
    disabled = false,
    ariaLabel = "Thinking level",
    onChange,
    touchFriendly = false,
    side = "top",
    align = "end",
}: {
    disabled?: boolean
    ariaLabel?: string
    value: ThinkingLevel
    onChange: (level: ThinkingLevel) => void
    touchFriendly?: boolean
    side?: "top" | "bottom" | "left" | "right"
    align?: "start" | "center" | "end"
}) {
    return (
        <Select
            selectedId={value}
            disabled={disabled}
            ariaLabel={ariaLabel}
            entries={THINKING_ENTRIES}
            onSelect={(entry) => onChange(entry.id)}
            noArrow
            side={side}
            align={align}
            className={{
                trigger: touchFriendly
                    ? "h-11 px-3 text-sm font-mono text-muted border border-border bg-transparent hover:bg-base-200"
                    : "h-7 px-2 text-xs font-mono text-muted border-0 bg-transparent hover:bg-base-200",
                value: touchFriendly ? "text-sm" : "text-xs",
            }}
        />
    )
}
